require 'angular'

angular.module('workflow.api')
  .factory('ResourceConfig', require('./resourceConfig'))
  .factory('ConcurrentResource', require('./concurrentResource'))
  .factory('endpoints', require('./endpoints'))
  .factory('PseudoTime', require('./pseudoTime'))
  .service('Api', require('./api'))
  .service('userApi', require('./userApi'))
  .service('Login', require('./login'))
  .service('polling', require('./polling'))
